<template>
  <div class="frame c-header">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="c-header__logo"></div>
          <h1>{{ $t("header.introheader") }}</h1>
          <p class="c-header__intro">
            {{ $t("header.introtext") }}
          </p>
          <p class="mb-0">{{ $t("header.assumptions") }}</p>
          <ul>
            <li>{{ $t("header.assumptions.item1") }}</li>
            <li>{{ $t("header.assumptions.item2") }}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header"
};
</script>
